import React, { useEffect } from "react";
import Header from "../Layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import NewHeader from "../Layout/NewHeader";
import NewSidebar from "../Layout/NewSidebar";

function Assets() {
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
    // dispatch(allapiAction.deshBoradDataUserData());
    dispatch(allapiAction.getprofile());

    return () => {};
  }, []);
  const copyAddress = () => {
    const text = "0x8168da3cCEB152C7b71eb04c11443a7733CdF37d";
    navigator.clipboard.writeText(text).then(() => {
      alert("Address copied!");
    });
  };

  return (
    <div>
      <NewHeader   />
      <NewSidebar />
      <div className="main" id="main">
      <div className="assets">
        {/* <!-- main-start --> */}
        <div class="container main-1-bg">
          <div class="row p-3">
            <div class="bg-light  rounded-4 ">
              <h6 class="text-center mt-4">Assets</h6>
              <h2 class="text-center fw-bold">
                {get_profile?.earningbalance ? get_profile?.earningbalance?.toFixed(4) : 0}
              </h2>
              <div class="d-flex justify-content-between">
                <div class="text-left">
                  <h5 class="">
                    <img
                      class="tlogo-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    {get_profile?.earningbalance
                      ? get_profile?.earningbalance?.toFixed(4)
                      : 0}
                  </h5>
                  <p>
                    <small>Total Earnings</small>
                  </p>
                </div>
                <div class="text-center">
                  <h5>
                    <img
                      class="tlogo-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0
                  </h5>
                  <p>
                    <small>withdraw</small>
                  </p>
                </div>
                {/* <div class="text-right">
                  <h5 class="text-center">
                    {" "}
                    <img
                      class="tlogo-img-position"
                      src="img/t logo.png"
                      alt=""
                    />{" "}
                    0
                  </h5>
                  <p>
                    <small>Unwithdrawl</small>
                  </p>
                </div> */}
              </div>
            </div>
          </div>

          {/* <div class="row p-2">
            <div class="d-flex justify-content-between gap-3">
              <div class="w-100">
                <select class="form-select" id="categorySelect">
                  <option value="Node 1">Node 1</option>
                  <option value="Node 2">Node 2</option>
                  <option value="Node 3">Node 3</option>
                </select>
              </div>
              <div class="">
                <img
                  class="mt-1 border rounded-circle p-1 main-1-bg border-warning"
                  src="img/icons8-help-18.png"
                  alt=""
                />
              </div>
            </div>
          </div> */}

          <div class="row p-3">
            <div class="bg-light rounded-4 pt-4 pb-2">
              <div class="d-flex justify-content-between">
                <div>
                  <h6> Deposit Address</h6>
                  <p>********************</p>
                </div>
                <div className="copy-btn" onClick={copyAddress}>
                  <img src="img/copy.svg" alt="" />
                </div>
              </div>

              {/* <div class="d-flex justify-content-between">
                <div>
                  <h6>USDT Deposit Address(TRC-20)</h6>
                  <p>********************</p>
                </div>
                <div>
                  <img src="img/copy.svg" alt="" />
                </div>
              </div> */}
            </div>
          </div>

          <div class="row p-3">
            <div class="bg-white rounded-4 pt-4 pb-2">
              <div class="d-flex justify-content-between">
                <div class="text-center">
                  <a class="text-decoration-none" href="/deposit">
                    <div>
                      <img src="img/credit-card.png" alt="" />
                    </div>
                    <p class="text-success mt-1"><b>Deposit</b></p>
                  </a>
                </div>

                <div class="text-center">
                  <a class="text-decoration-none" href="/withdrawladd">
                    <div>
                      <img src="img/withdraw.png" alt="" />
                    </div>
                    <p class="text-warning mt-1">Withdraw</p>
                  </a>
                </div>

                {/* <div class="text-center">
                  <a class="text-decoration-none" href="/settingNew">
                    <div>
                      <img src="img/settings.png" alt="" />
                    </div>
                    <p class="text-dark mt-1">Settings</p>
                  </a>
                </div> */}
              </div>

              <div class="p-3">
                <button type="button" class="w-100 btn rounded-pill main-1-btn">
                  <h5 class="my-2"> Recharge</h5>
                </button>
              </div>
            </div>
          </div>

          {/* <div class="row p-3 mb-5">
            <div class="bg-white rounded-4 pb-4">
              <div class="mt-4 d-flex justify-content-between">
                <h6 class="fw-bold">History</h6>
                <a class="text-decoration-none text-dark" href="">
                  <h6 class="fw-bold">
                    All <img src="img/icons8-right-arrow-24.png" alt="" />
                  </h6>
                </a>
              </div>

              <hr />
              

              <div class="col d-flex flex-column">
                <div class="d-flex justify-content-between ">
                  <h6>Trial fund recovery</h6>
                  <h6 class="text-danger fw-bold">-150</h6>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="mt-2 text-muted">2025-02-27 14:13:35</p>
                  <button class="btn btn-success btn-sm">success</button>
                </div>
              </div>

              <div class="col d-flex flex-column ">
                <div class="d-flex justify-content-between ">
                  <h6>Trial fund </h6>
                  <h6 class="text-success fw-bold">+150</h6>
                </div>
                <div class=" d-flex justify-content-between align-items-center">
                  <p class="text-muted mt-2">2025-02-25 14:09:03</p>
                  <button class="btn btn-success btn-sm">success</button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <!-- main-end --> */}
        <div style={{ height: "100px" }}></div>
      </div>
      </div>
    </div>
  );
}

export default Assets;
